(function() {
  // Generate or load session ID
  if (!localStorage.getItem('ck_session_id')) {
    localStorage.setItem('ck_session_id', 'ck_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9));
  }
  var sessionId = localStorage.getItem('ck_session_id');

  // ALWAYS attach session ID to cart on every page load
  // (this fixes returning customers, iPhone users, and race conditions)
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { 'ck_session_id': sessionId }
    })
  });

  var scriptURL = 'https://script.google.com/macros/s/AKfycbwXiQCucz0OEoIopRf6cj1W27xm3we0NXZ_H_uW7c9edD-JKW4MGHAtA-FzHh1a6pbN_w/exec';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : '';
  }

  // Exposed globally so ck-no-match-popup.js can call window.ckTrack('no_match_shown') etc.
  window.ckTrack = function(eventName) {
    var sid = localStorage.getItem('ck_session_id') || '';
    if (!sid) return;
    fetch(scriptURL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: eventName, session_id: sid })
    });
  };

  // Device detection ping — only fires once per device, skips iPhone
  if (localStorage.getItem('ck_sent')) return;
  if (/iPhone/i.test(navigator.userAgent)) return;

  function send(model) {
    fetch(scriptURL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model: model,
        ua: navigator.userAgent,
        ip: "",
        referrer: document.referrer || "direct",
        session_id: sessionId,
        fbc: getCookie('_fbc'),
        fbp: getCookie('_fbp')
      })
    });

    localStorage.setItem('ck_sent', '1');
  }

  function fromUA() {
    var m = navigator.userAgent.match(/;\s*([^;]+?)\s+Build\//i) ||
            navigator.userAgent.match(/\(([^;)]+);/);
    return m ? m[1].trim() : "Unknown";
  }

  if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
    navigator.userAgentData.getHighEntropyValues(["model"])
      .then(function(u) { send(u.model || fromUA()); })
      .catch(function() { send(fromUA()); });
  } else {
    send(fromUA());
  }

})();